// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementEmailMessageDndEditorAccessTokenResult = objectOf({
  access_token: string,
  token_type: string,
  expires_in: number,
  refresh_token: string,
  "as:client_id": string,
  userName: string,
  "as:region": string,
  ".issued": string,
  ".expires": string,
});
